import React from "react";
import { Modal } from "semantic-ui-react";
import { YearlyCoursePricing } from "../../../../stores/PricingStore/Types";

interface PermissionGateProp {
  isOpen: boolean;
  closeModal: (state: boolean) => void;
  isLoggedIn: boolean;
  communityPricing?: YearlyCoursePricing;
}

const PermissionGateModal = ({
  isOpen,
  closeModal,
  isLoggedIn,
  communityPricing,
}: PermissionGateProp) => {
  const currencySymbol = communityPricing?.currency_symbol || "$";
  const amount = communityPricing?.amount || "8";
  const currencyCode = communityPricing?.currency_code;
  const checkoutUrl = communityPricing?.checkout_url || "/passes/community/pay";

  return (
    <Modal
      onClose={() => closeModal(false)}
      open={isOpen}
      size="small"
      className="community-locked-modal"
      closeOnDimmerClick
    >
      <div className="gate-card">
        <button
          type="button"
          className="rules-modal-close"
          aria-label="Close"
          onClick={() => closeModal(false)}
        >
          ×
        </button>
        <div className="gate-lock" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2E2437"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <div className="gate-eyebrow">Members only</div>
        <h2 id="gate-title">
          There's a great party going on. <em>Want in?</em>
        </h2>

        <div className="gate-perks">
          <div className="gate-perk">
            <span className="gate-perk-icon-svg" aria-hidden="true">
              <svg viewBox="0 0 32 32">
                <use href="#ic-chat" />
              </svg>
            </span>
            <span className="gate-perk-text">
              <strong>Talk with clever people</strong>170+ countries. Designers,
              founders, marketers, the lot.
            </span>
          </div>
          <div className="gate-perk">
            <span className="gate-perk-icon-svg" aria-hidden="true">
              <svg viewBox="0 0 32 32">
                <use href="#ic-sparkle" />
              </svg>
            </span>
            <span className="gate-perk-text">
              <strong>AI tools for your work</strong>Custom-built to help you
              apply the skills we teach.
            </span>
          </div>
          <div className="gate-perk">
            <span className="gate-perk-icon-svg" aria-hidden="true">
              <svg viewBox="0 0 32 32">
                <use href="#ic-books" />
              </svg>
            </span>
            <span className="gate-perk-text">
              <strong>Handy Resources</strong>Trend reports, decks, hard-to-find
              research.
            </span>
          </div>
          <div className="gate-perk">
            <span className="gate-perk-icon-svg" aria-hidden="true">
              <svg viewBox="0 0 32 32">
                <use href="#ic-flame" />
              </svg>
            </span>
            <span className="gate-perk-text">
              <strong>Bright, not boastful</strong>Real thinking, not personal
              brand building.
            </span>
          </div>
        </div>

        <div className="gate-offer">
          <div className="gate-offer-row">
            <div className="gate-offer-price">
              <span className="gate-offer-currency">{currencySymbol}</span>
              <span className="gate-offer-amount">{amount}</span>
              {currencyCode && (
                <span className="gate-offer-code">{currencyCode}</span>
              )}
              <span className="gate-offer-per">/month</span>
            </div>
            <div className="gate-offer-text">
              <strong>Community Hub access</strong>
              <span>Pay as you go. Stop any time.</span>
            </div>
          </div>
          <a
            href={checkoutUrl}
            className="gate-btn gate-btn-primary gate-btn-block"
          >
            Join the community &rarr;
          </a>
        </div>

        <div className="gate-alts">
          {!isLoggedIn && (
            <a href="/login" className="gate-alt">
              <span className="gate-alt-label">
                Already an All Access Pass holder?
              </span>
              <span className="gate-alt-cta">Sign in &rarr;</span>
            </a>
          )}
          <a href="/courses" className="gate-alt">
            <span className="gate-alt-label">
              Buying a course? You'll get 3 months in here free.
            </span>
            <span className="gate-alt-cta">Browse courses &rarr;</span>
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionGateModal;
